import React from "react";
import "../styles/WhoWeAre.css";

function WhoWeAre() {
  return (
    <section id="who-we-are" className="who-we-are-section">
      <div className="section-container who-we-are-container">
        {/* Left side: text */}
        <div className="who-we-are-text">
          <h2>Who We Are</h2>
          <p>
            We are a new-age law firm—driven by technology, yet deeply rooted in the age-old wisdom of natural justice.
          </p>
          <p>
            Whether you face a challenge or a choice, we safeguard your best interests.
          </p>
        </div>

        {/* Right side: image */}
        <div className="who-we-are-image">
          <img src="/WhoWeAre.jpeg" alt="About Nyayom Legal Services" />
        </div>
      </div>
    </section>
  );
}

export default WhoWeAre;